// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 건강보험연말정산 화면 */
.health-settlement {
  min-height: calc(100vh - 80px);
  background-color: #f8f9fa;
}

.health-layout {
  display: flex;
  min-height: calc(100vh - 80px);
}

.health-sidebar {
  width: 350px;
  min-width: 350px;
  background: white;
  border-right: 1px solid #e1e5e9;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  /* 화면 높이에 고정 — 기업 목록이 자체 스크롤을 갖고 본문으로 스크롤이 번지지 않게 */
  position: sticky;
  top: 80px;
  height: calc(100vh - 80px);
  overflow: hidden;
}

.health-content {
  flex: 1 1;
  background: white;
  overflow: auto;
  padding: 1.5rem;
}

.health-guide {
  text-align: center;
  padding: 4rem 2rem;
  color: #6c757d;
}

.health-guide h2 {
  color: #495057;
  margin-bottom: 1rem;
}

.health-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.health-header h2 {
  margin: 0;
  color: #495057;
  font-size: 1.3rem;
}

.health-controls {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.health-controls label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.9rem;
  color: #495057;
}

.health-controls select {
  padding: 0.35rem 0.6rem;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 0.9rem;
}

.health-excel-btn {
  background: #17a2b8;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.45rem 1rem;
  font-size: 0.9rem;
  cursor: pointer;
}

.health-excel-btn:hover:not(:disabled) {
  background: #138496;
}

.health-excel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.health-empty {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
  background: #f8f9fa;
  border-radius: 10px;
}

.health-summary {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  font-size: 0.85rem;
}

.health-summary span {
  background: #f8f9fa;
  border: 1px solid #e1e5e9;
  border-radius: 6px;
  padding: 0.25rem 0.6rem;
  color: #495057;
}

.health-summary span.grand {
  background: #cfe2ff;
  border-color: #0d6efd;
  color: #084298;
  font-weight: 700;
}

.health-table-wrapper {
  overflow: auto;
  max-height: calc(100vh - 280px);
  border: 1px solid #dee2e6;
  border-radius: 8px;
}

.health-table {
  border-collapse: collapse;
  font-size: 0.82rem;
  background: white;
  width: max-content;
}

.health-table th,
.health-table td {
  border: 1px solid #dee2e6;
  padding: 0.35rem 0.5rem;
  white-space: nowrap;
}

.health-table thead th {
  background: #f1f3f5;
  color: #495057;
  position: sticky;
  top: 0;
  z-index: 5;
}

.health-table thead tr:nth-child(2) th {
  top: 29px; /* 1행 높이만큼 아래에 고정 */
}

.health-table thead th.sub {
  font-weight: 500;
  font-size: 0.75rem;
  color: #6c757d;
}

.health-table .sticky-col {
  position: sticky;
  left: 0;
  background: #f8f9fa;
  z-index: 4;
  font-weight: 600;
}

.health-table thead .sticky-col {
  z-index: 6;
}

.health-table .name-col {
  color: #212529;
}

.health-table .rrn-col {
  font-family: monospace;
  color: #495057;
}

.health-table td.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.health-table td.total {
  background: #f8f9fa;
  font-weight: 600;
}

.health-table td.grand {
  background: #e7f1ff;
  font-weight: 700;
  color: #084298;
}

.health-table tfoot td {
  background: #f1f3f5;
  font-weight: 700;
  border-top: 2px solid #495057;
}

@media (max-width: 900px) {
  .health-layout {
    flex-direction: column;
  }
  .health-sidebar {
    width: 100%;
    min-width: 0;
  }
}

/* 그 해 퇴직자 명단: 결과 표 아래, 내용 폭만큼만 */
.health-retired { margin-top: 18px; }
.health-retired h3 { margin: 0 0 8px; font-size: 15px; }
.health-retired h3 span { margin-left: 8px; color: #6c757d; font-size: 12.5px; font-weight: 400; }
.health-retired .health-table { width: auto; }
.health-retired .health-table th,
.health-retired .health-table td { padding: 6px 16px; text-align: center; }
`, "",{"version":3,"sources":["webpack://./src/components/HealthInsuranceSettlement.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,mDAAmD;EACnD,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,SAAS,EAAE,mBAAmB;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,iCAAiC;AACjC,kBAAkB,gBAAgB,EAAE;AACpC,qBAAqB,eAAe,EAAE,eAAe,EAAE;AACvD,0BAA0B,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACjG,gCAAgC,WAAW,EAAE;AAC7C;mCACmC,iBAAiB,EAAE,kBAAkB,EAAE","sourcesContent":["/* 건강보험연말정산 화면 */\r\n.health-settlement {\r\n  min-height: calc(100vh - 80px);\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.health-layout {\r\n  display: flex;\r\n  min-height: calc(100vh - 80px);\r\n}\r\n\r\n.health-sidebar {\r\n  width: 350px;\r\n  min-width: 350px;\r\n  background: white;\r\n  border-right: 1px solid #e1e5e9;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);\r\n  /* 화면 높이에 고정 — 기업 목록이 자체 스크롤을 갖고 본문으로 스크롤이 번지지 않게 */\r\n  position: sticky;\r\n  top: 80px;\r\n  height: calc(100vh - 80px);\r\n  overflow: hidden;\r\n}\r\n\r\n.health-content {\r\n  flex: 1;\r\n  background: white;\r\n  overflow: auto;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.health-guide {\r\n  text-align: center;\r\n  padding: 4rem 2rem;\r\n  color: #6c757d;\r\n}\r\n\r\n.health-guide h2 {\r\n  color: #495057;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.health-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.health-header h2 {\r\n  margin: 0;\r\n  color: #495057;\r\n  font-size: 1.3rem;\r\n}\r\n\r\n.health-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.health-controls label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  font-size: 0.9rem;\r\n  color: #495057;\r\n}\r\n\r\n.health-controls select {\r\n  padding: 0.35rem 0.6rem;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 6px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.health-excel-btn {\r\n  background: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 0.45rem 1rem;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.health-excel-btn:hover:not(:disabled) {\r\n  background: #138496;\r\n}\r\n\r\n.health-excel-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.health-empty {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  color: #6c757d;\r\n  background: #f8f9fa;\r\n  border-radius: 10px;\r\n}\r\n\r\n.health-summary {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 1rem;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.health-summary span {\r\n  background: #f8f9fa;\r\n  border: 1px solid #e1e5e9;\r\n  border-radius: 6px;\r\n  padding: 0.25rem 0.6rem;\r\n  color: #495057;\r\n}\r\n\r\n.health-summary span.grand {\r\n  background: #cfe2ff;\r\n  border-color: #0d6efd;\r\n  color: #084298;\r\n  font-weight: 700;\r\n}\r\n\r\n.health-table-wrapper {\r\n  overflow: auto;\r\n  max-height: calc(100vh - 280px);\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 8px;\r\n}\r\n\r\n.health-table {\r\n  border-collapse: collapse;\r\n  font-size: 0.82rem;\r\n  background: white;\r\n  width: max-content;\r\n}\r\n\r\n.health-table th,\r\n.health-table td {\r\n  border: 1px solid #dee2e6;\r\n  padding: 0.35rem 0.5rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.health-table thead th {\r\n  background: #f1f3f5;\r\n  color: #495057;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 5;\r\n}\r\n\r\n.health-table thead tr:nth-child(2) th {\r\n  top: 29px; /* 1행 높이만큼 아래에 고정 */\r\n}\r\n\r\n.health-table thead th.sub {\r\n  font-weight: 500;\r\n  font-size: 0.75rem;\r\n  color: #6c757d;\r\n}\r\n\r\n.health-table .sticky-col {\r\n  position: sticky;\r\n  left: 0;\r\n  background: #f8f9fa;\r\n  z-index: 4;\r\n  font-weight: 600;\r\n}\r\n\r\n.health-table thead .sticky-col {\r\n  z-index: 6;\r\n}\r\n\r\n.health-table .name-col {\r\n  color: #212529;\r\n}\r\n\r\n.health-table .rrn-col {\r\n  font-family: monospace;\r\n  color: #495057;\r\n}\r\n\r\n.health-table td.num {\r\n  text-align: right;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.health-table td.total {\r\n  background: #f8f9fa;\r\n  font-weight: 600;\r\n}\r\n\r\n.health-table td.grand {\r\n  background: #e7f1ff;\r\n  font-weight: 700;\r\n  color: #084298;\r\n}\r\n\r\n.health-table tfoot td {\r\n  background: #f1f3f5;\r\n  font-weight: 700;\r\n  border-top: 2px solid #495057;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .health-layout {\r\n    flex-direction: column;\r\n  }\r\n  .health-sidebar {\r\n    width: 100%;\r\n    min-width: 0;\r\n  }\r\n}\r\n\r\n/* 그 해 퇴직자 명단: 결과 표 아래, 내용 폭만큼만 */\r\n.health-retired { margin-top: 18px; }\r\n.health-retired h3 { margin: 0 0 8px; font-size: 15px; }\r\n.health-retired h3 span { margin-left: 8px; color: #6c757d; font-size: 12.5px; font-weight: 400; }\r\n.health-retired .health-table { width: auto; }\r\n.health-retired .health-table th,\r\n.health-retired .health-table td { padding: 6px 16px; text-align: center; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
